import { Tag } from "antd";
import get from "lodash/get";
import { Typography } from "antd";
import {
  convertTimeRangeToAmPm,
  getTransformedMinutes,
} from "../../utilities/helpers";
import { useState } from "react";

const { Text, Paragraph } = Typography;
const cellStyle = {
  padding: "2px",
  paddingTop: "10px",
  paddingBottom: "10px",
  textAlign: "center",
};
const ReportDesc = ({ text }) => {
  const [ellipsis, setellipsis] = useState(false);
  return (
    <Paragraph
      ellipsis={{
        rows: 2,
        expandable: "collapsible",
        ellipsis,
        onExpand: (_, info) => setellipsis(info.expanded),
      }}
    >
      {text}
    </Paragraph>
  );
};
export const breakdownReport = (filter, template_type = 1) => {
  switch (template_type) {
    case 1:
      return [
        {
          title: "Machine",
          dataIndex: "name",
          key: "name",
          onHeaderCell: () => ({
            style: { padding: "4px", textAlign: "center" },
          }),
          onCell: () => ({
            style: cellStyle,
          }),
          width: "150px",
          render: () => (
            <Tag color="blue" className="min-w-max">
              {get(filter, "template_name")}
            </Tag>
          ),
        },
        {
          title: "Date",
          dataIndex: "date_formatted",
          key: "date",
          width: "150px",
          onHeaderCell: () => ({
            style: { padding: "4px", textAlign: "center" },
          }),
          onCell: () => ({
            style: cellStyle,
          }),
          render: (text) => (
            <Text strong style={{ padding: "2px" }}>
              {text}
            </Text>
          ),
        },
        {
          title: "Time Slot",
          dataIndex: "slot",
          key: "slot",
          width: "150px",
          onHeaderCell: () => ({
            style: { padding: "4px", textAlign: "center" },
          }),
          onCell: () => ({
            style: cellStyle,
          }),
          render: (text) => (
            <Tag color="green" className="min-w-max">
              {convertTimeRangeToAmPm(text)}
            </Tag>
          ),
        },
        {
          title: "Idle Time",
          dataIndex: ["meta", "idle_time"],
          key: "idle_time",
          width: "130px",
          onHeaderCell: () => ({
            style: { padding: "4px", textAlign: "center" },
          }),
          onCell: () => ({
            style: cellStyle,
          }),
          render: (text) => <Text>{getTransformedMinutes(Number(text))}</Text>,
        },
        {
          title: "Off Time",
          dataIndex: ["meta", "off_time"],
          key: "off_time",
          width: "130px",
          onHeaderCell: () => ({
            style: { padding: "4px", textAlign: "center" },
          }),
          onCell: () => ({
            style: cellStyle,
          }),
          render: (text) => <Text>{getTransformedMinutes(Number(text))}</Text>,
        },
        {
          title: "Reason",
          dataIndex: ["reason"],
          key: "reason",
          width: "25%",
          render: (reason) => (
            <Tag
              color="purple"
              className="text-center mb-0 max-w-[400px] p-1 min-w-[200px]"
            >
              {get(reason, "reason", "--") || reason}
            </Tag>
          ),
          onHeaderCell: () => ({
            style: { padding: "4px", textAlign: "center" },
          }),
          onCell: () => ({
            style: cellStyle,
          }),
        },
        {
          title: "Description",
          dataIndex: ["description"],
          key: "description",
          width: "25%",
          render: (text) => <ReportDesc text={text} />,
          onHeaderCell: () => ({
            style: { padding: "4px", textAlign: "center" },
          }),
          onCell: () => ({
            style: { ...cellStyle, maxWidth: "150px", padding: "10px" },
          }),
        },
      ];
  }
};
